import { UseFormReturn } from "react-hook-form";

export const shouldShowSkipStep = <T extends object>(form: UseFormReturn<T>): boolean => {
  const values = form.getValues();
  return (
    !Object.values(values).some((value: unknown) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === "number") {
        return value !== 0;
      }
      if (value === null || value === undefined) {
        return false;
      }
      return Boolean(value);
    }) && !form.formState.isDirty
  );
};
